<template>
  <section :class="$style.description">
    <h2>{{ t('details.DESCRIPTION') }}</h2>
    <div
      v-if="!isContainingContactInformation"
      :class="$style.descriptionBody"
      v-html="listingDescription"
    />
    <div v-else :class="$style.descriptionBody">
      <MaskedDescription
        :description="listingDescription"
        @maskedContentClicked="emit('maskedContentClicked')"
      />
    </div>
  </section>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

import MaskedDescription from '@/components/TenantPlus/MaskedDescription.vue';
import { useListingLocalizedContent } from '@/composables/useListingLocalizedContent';
import { sanitizeHtml } from '@/helpers/Sanitize/Sanitize';
import { removeLinksFromDescription } from '@/helpers/TextFormatting/TextFormatting';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const { listingDescription: resolvedDescription } = useListingLocalizedContent();

const LINK_EXCEPTIONS = ['mywincasa.ch'];

const emit = defineEmits<{
  maskedContentClicked: [];
}>();

const listingDescription = computed((): string => {
  const rawDescription = resolvedDescription.value ?? '';

  // Sanitise once here so both the v-html path and the MaskedDescription path
  // below receive already-clean HTML (defense-in-depth over listing-api).
  return sanitizeHtml(removeLinksFromDescription(rawDescription, LINK_EXCEPTIONS));
});
const isContainingContactInformation = computed((): boolean => {
  return listingDescription.value.includes('<span class="tenantPlusExclusive">');
});
</script>

<style lang="scss" module>
@import '@/assets/variables';

.descriptionBody {
  hyphens: auto;
  word-break: break-word;

  p,
  li {
    line-height: var(--typo-body-2-line-height);
  }

  p {
    margin: 0;
  }

  p + p,
  ul + p,
  ol + p,
  br + ul,
  br + ol,
  p + ul,
  p + ol,
  strong + ul,
  strong + ol,
  li + li {
    margin-top: $space-100;
  }

  ul,
  ol {
    margin-bottom: 0;
  }

  li p {
    display: inline;
    margin: 0;
  }
}
</style>
